
import FormDialog from "../../helpers/FormDialog";
import moment from "moment";

export const CriminalRecordEdit = ({
    onSuccess,
    setOpen,
    open,
    resourceId,
    setValue0,
    value,
}) => {
    return (
        <FormDialog
            maxWidth={"md"}
            open={open > 0}
            onSuccess={onSuccess}
            setOpen={setOpen}
            url={open === 1 ? "/api/resource/criminal-record/:resourceId" : `/api/resource/criminal-record/update/${resourceId}`}
            title={open === 1 ? "Add Criminal Record" : " Update Criminal Record"}
            fields={[
                {
                    name: "beenImprisoned",
                    label: "Have you been imprisoned?",
                    type: "radio",
                    values: [
                        { label: "Yes", value: "yes" },
                        { label: "No", value: "no" },
                    ],
                    value: value["beenImprisoned"],
                    setValue: (val) => {
                        setValue0("beenImprisoned", val);
                        if (val === "no") {
                            setValue0("imprisonmentDetails", "");
                            setValue0("imprisonmentDuration", "");
                        }
                    },
                    required: true,
                },
                ...(value["beenImprisoned"] === "yes"
                    ? [
                        {
                            name: "startDate",
                            label: "Started At",
                            type: "date",
                            required: true,
                            value: value["startDate"],
                            setValue: (val) => {
                                setValue0("startDate", val);
                            },
                            showIf: (values) => values?.beenImprisoned === "yes",

                            validate: (v) => {
                                if (!v) return "Start date is required";
                                const today = moment().startOf("day");
                                if (moment(v).isAfter(today)) {
                                    return "Start date must be in the past";
                                }
                                return true;
                            },

                        },
                        {
                            name: "endDate",
                            label: "Ended At",
                            type: "date",
                            required: true,
                            value: value["endDate"],
                            minDate: value["startDate"] ? moment(value["startDate"]) : undefined,
                            setValue: (val) => {
                                setValue0("endDate", val);
                            },
                            showIf: (values) => values?.beenImprisoned === "yes",
                            validate: (v) => {
                                const startDate = value["startDate"];
                                if (!v && startDate) return "End date is required if start date is provided";
                                if (!v) return "End date is required";
                                if (startDate && moment(v).isBefore(moment(startDate))) {
                                    return "End date cannot be before start date";
                                }
                                const today = moment().startOf("day");
                                if (moment(v).isAfter(today)) {
                                    return "End date must be in the past";
                                }
                                return true;
                            },
                        },


                        {
                            name: "location",
                            label: "Location of imprisonment",
                            type: "text",
                            value: value["location"],
                            setValue: (val) => setValue0("location", val),
                            showIf: (values) => values?.beenImprisoned === "yes",
                        },
                        {
                            name: "imprisonmentReason",
                            label: "Reason for imprisonment",
                            type: "text",
                            value: value["imprisonmentReason"],
                            setValue: (val) => setValue0("imprisonmentReason", val),
                            showIf: (values) => values?.beenImprisoned === "yes",
                        }
                    ]
                    : []),

            ]}
        />
    );
};